export interface Issue {
  id: string;
  label: string;
  quickFix?: string;
}

export interface Category {
  id: string;
  label: string;
  issues: Issue[];
}

export const DECISION_TREE: Category[] = [
  {
    id: "ai_translation",
    label: "AI Translation",
    issues: [
      {
        id: "translation_not_working",
        label: "Translation not working",
        quickFix:
          "Try re-uploading the file and make sure it is in a supported format (XLSForm, CSV). If the issue persists, check your available tokens.",
      },
      {
        id: "wrong_output",
        label: "Wrong translation output",
        quickFix:
          "Review the source language settings and ensure the correct target language is selected before running the translation.",
      },
      {
        id: "upload_failed",
        label: "File upload failed",
        quickFix:
          "Make sure your file is under the size limit and in a supported format. Try a different browser if the issue continues.",
      },
      { id: "other_translation", label: "Other" },
    ],
  },
  {
    id: "data_cleaning",
    label: "Data Cleaning",
    issues: [
      {
        id: "cannot_upload",
        label: "Cannot upload dataset",
        quickFix:
          "Check that your file format is supported (CSV, XLS, XLSX) and that it does not exceed the maximum file size.",
      },
      {
        id: "data_not_processing",
        label: "Data not processing",
        quickFix:
          "Refresh the page and try restarting the process. If the job is stuck, wait a few minutes — large datasets may take longer.",
      },
      {
        id: "export_failed",
        label: "Export failed",
        quickFix:
          "Try exporting again. If the problem persists, try a different export format.",
      },
      { id: "other_cleaning", label: "Other" },
    ],
  },
  {
    id: "project_hub",
    label: "Project Hub",
    issues: [
      {
        id: "cannot_create_task",
        label: "Cannot create task",
        quickFix:
          "Make sure you have the correct permissions for this project. Contact your project Admin if you are unable to create tasks.",
      },
      {
        id: "task_not_updating",
        label: "Task not updating",
        quickFix:
          "Try refreshing the page. If the task status is stuck, re-open the task and save it again.",
      },
      {
        id: "members_not_showing",
        label: "Members not showing",
        quickFix:
          "Check that the members have been added to the project. Only project members will appear in the assignee list.",
      },
      { id: "other_hub", label: "Other" },
    ],
  },
  {
    id: "dashboard",
    label: "Dashboard",
    issues: [
      {
        id: "dashboard_not_loading",
        label: "Dashboard not loading",
        quickFix:
          "Clear your browser cache and reload. Make sure you have at least one dataset connected to the dashboard.",
      },
      {
        id: "charts_not_showing",
        label: "Charts not showing",
        quickFix:
          "Verify that your data source is connected and has the required fields. Try re-selecting the data source in the chart settings.",
      },
      {
        id: "export_issue",
        label: "Export issue",
        quickFix:
          "Try exporting again. Make sure your browser allows file downloads from this site.",
      },
      { id: "other_dashboard", label: "Other" },
    ],
  },
  {
    id: "balanced_scorecard",
    label: "Balanced Scorecard",
    issues: [
      {
        id: "cannot_create",
        label: "Cannot create scorecard",
        quickFix:
          "Ensure you have Admin or Project Manager permissions. Check that all required fields are filled in before saving.",
      },
      {
        id: "data_not_syncing",
        label: "Data not syncing",
        quickFix:
          "Try refreshing the scorecard. If data is still outdated, disconnect and reconnect the data source.",
      },
      { id: "other_scorecard", label: "Other" },
    ],
  },
  {
    id: "audit_trails",
    label: "Audit Trails",
    issues: [
      {
        id: "logs_not_showing",
        label: "Logs not showing",
        quickFix:
          "Check the date filter — logs may be outside the selected range. Ensure you have Admin access to view audit trails.",
      },
      {
        id: "export_audit_failed",
        label: "Export failed",
        quickFix:
          "Try exporting a smaller date range. If the issue persists, try a different browser.",
      },
      { id: "other_audit", label: "Other" },
    ],
  },
  {
    id: "other",
    label: "Other",
    issues: [],
  },
];
